import React from 'react';
import { FlexBox, Span } from '@vp/swan';

type PageLabelProps = {
  labels?: string[];
};

export const PageLabel = ({ labels }: PageLabelProps) => {
  if (!labels?.length) return null;

  return (
    <FlexBox
      px={7}
      mt={5}
      justifyContent={labels.length <= 1 ? 'center' : 'space-between'}
      fontSize="small"
      textColor="subtle"
    >
      {labels.map((label, i) => {
        return <Span key={i}>{label}</Span>;
      })}
    </FlexBox>
  );
};
